import { NotificationsAlertsService } from '@notifications/infra';
import { inject } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { NOTIFICATION_TOKEN, NotificationPermissionProvider, PLATFORM_TOKEN, PlatformProvider } from '@core';

export class PushPermissionsStatusCommandHandler {
  private notificationsAlertsService: NotificationsAlertsService = inject(NotificationsAlertsService);
  private platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);
  private notificationPermissionProvider: NotificationPermissionProvider = inject(NOTIFICATION_TOKEN);

  setValue(): Observable<void> {
    if (!this.platformProvider.isNativeRun) return of(void 0);

    return this.notificationPermissionProvider
      .isEnabled()
      .pipe(switchMap((isEnabled: boolean) => this.notificationsAlertsService.setPushStatus(isEnabled)));
  }
}
